import React, { useCallback, useMemo } from 'react';
import { Button, Modal, ModalTitle } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useHistory } from "react-router-dom";

const ExitTourModal = React.memo((props) => {
    // Destructure props for better performance and linting compliance
    const { showExitTour, setShowExitTour } = props;

    const history = useHistory();

    // Memoized event handlers with useCallback for stable references
    const closeModal = useCallback(() => {
        setShowExitTour(false);
        history.push('/');
    }, [setShowExitTour, history]);

    const goBackToTour = useCallback(() => {
        setShowExitTour(false);
    }, [setShowExitTour]);

    // Memoized modal props and styles
    const modalProps = useMemo(() => ({
        dialogClassName: "fullscreenmodal",
        show: showExitTour,
        backdrop: "static",
        keyboard: false,
        id: "about"
    }), [showExitTour]);

    const headerTitleStyle = useMemo(() => ({
        className: "aboutHead"
    }), []);

    const modalBodyTitleStyle = useMemo(() => ({
        className: "titleBody stepBody"
    }), []);

    const buttonContainerStyle = useMemo(() => ({
        className: 'stepTourButtons'
    }), []);

    const backButtonStyle = useMemo(() => ({
        className: "mr-2 buttonSearch submitColor buttonTour"
    }), []);

    const exitButtonStyle = useMemo(() => ({
        className: "mr-2 buttonSearch resetColor buttonTour"
    }), []);

    // Memoized modal content
    const modalContent = useMemo(() => (
        "Do you want to exit the tour?"
    ), []);

    return (
        <>
            <Modal {...modalProps}>
                <Modal.Header>
                    <Modal.Title {...headerTitleStyle}>
                        Exit Tour
                    </Modal.Title>
                </Modal.Header>
                
                <Modal.Body>
                    <ModalTitle {...modalBodyTitleStyle}>
                        {modalContent}
                    </ModalTitle>
                </Modal.Body>
                
                <div {...buttonContainerStyle}>
                    <Button 
                        {...backButtonStyle}
                        onClick={goBackToTour}
                    >
                        Back
                    </Button>
                    <Button 
                        {...exitButtonStyle}
                        onClick={closeModal}
                    >
                        Exit
                    </Button>
                </div>
            </Modal>
        </>
    );
});

ExitTourModal.displayName = 'ExitTourModal';

ExitTourModal.propTypes = {
    showExitTour: PropTypes.bool.isRequired,
    setShowExitTour: PropTypes.func.isRequired
};

export default ExitTourModal;
  